var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('faq',{attrs:{"title":_vm.$prismic.asText(_vm.slice.primary.h3),"questions-and-answers":_vm.items}})}
var staticRenderFns = []

export { render, staticRenderFns }